import { Outlet, useNavigate, useParams } from "react-router-dom";

import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";
import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import {
    ViewDatabaseGuard,
    ViewChartsOfAccountsDashboard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";

import {
    chartsOfAccountsTabsValidator,
    routerPaths,
} from "@/ui/router/routerPaths";
import { useEffect } from "react";

const PageChartsOfAccountsDashboard = () => {
    const navigate = useNavigate();
    const onClickBackButton = () => {
        navigate(routerPaths.main.default());
    };

    const { tab } = useParams() as {
        tab: string;
    };

    useEffect(() => {
        const isValidTab = chartsOfAccountsTabsValidator(tab);
        if (isValidTab) return;
        navigate(routerPaths.chartsOfAccounts.dashboard("list"));
    }, [navigate, tab]);

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard>
                    <LayoutFillParentCentered>
                        {chartsOfAccountsTabsValidator(tab) && (
                            <ViewChartsOfAccountsDashboard
                                onClickBackButton={onClickBackButton}
                                activeTab={tab}
                                setActiveTab={targetTabName => {
                                    navigate(
                                        routerPaths.chartsOfAccounts.dashboard(
                                            targetTabName,
                                        ),
                                    );
                                }}
                            />
                        )}
                    </LayoutFillParentCentered>
                </ViewDatabaseGuard>
            </ErrorBoundary>
            <Outlet />
        </LayoutFullScreen>
    );
};

export default PageChartsOfAccountsDashboard;
